<!--头部banner组件-->
<template>
 <div class="top-box flex-c-sb">
   <router-link to="/" class="logo flex-c">
     <div class="logo-icon"><img class="img-height" src="../assets/logo_red.png" alt=""></div>
     <div class="logo-text">山西华夏营造集团股份有限公司</div>
   </router-link>
   <div class="flex-c nav-more" @click="drawer = true">
     <div class="nav-more-text flex-column-c-c">
       导 航
       <div class="nav-en">MENU</div>
     </div>
     <div class="nav-more-icon el-icon-menu"></div>
   </div>
   <el-drawer :visible.sync="drawer" :append-to-body="true" size="50%" :modal="true" :show-close="false">
     <div class="flex-c-c" slot="title">
       <div class="app-nav-icon">
         <img class="img-height" src="../assets/logo_red.png" alt="">
       </div>
     </div>
     <div class="app-nav" @click="drawer = false">
       <router-link class="app-nav-item" v-for="item in navBar" :key="item.id" :to="item.router">
         {{item.name}}
       </router-link>
     </div>
   </el-drawer>
   <div class="nav-list flex-c">
     <router-link class="nav-item" v-for="item in navBar" :key="item.id" :to="item.router">
       {{item.name}}
     </router-link>
<!--     <router-link class="el-icon-search" to="/"></router-link>-->
   </div>
 </div>
</template>

<script>
  import {ajaxGet, ajaxPost,imagePrefixUrl,ajaxUrl} from "../utils/ajax";
  export default {
    name: "Header",
    components:{},
    computed: {
      navBar() {
        let nav;
        nav = [
          {name:'网站首页', router:'/', id: 1,},
          {name:'集团简介', router: '/about', id: 2,},
          {name:'集团案例', router:'/case', id: 3, },
          {name:'集团新闻', router:'/new', id: 4, },
          {name:'资质荣誉', router:'/honour', id: 5, },
          {name:'合作伙伴', router:'/partner', id: 6, },
          {name:'联系我们', router:'/contact', id: 7, },
        ];
        return nav;
      }
    },
    data() {
      return {
        drawer: false,
      }
    },
    mounted() {

    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .top-box{
    position: absolute;top: 0;left: 0;width: 100%;z-index: 10;padding: 14px 140px 14px 72px;
    .logo {
      .logo-icon { height: 80px;margin-right: 16px;}
      .logo-text { font-size: 22px;color: $theme-color;letter-spacing: 1px;font-weight: bold;}
    }
    .nav-more { display: none;}
    .nav-list {
      .nav-item {
        font-size: 18px;color: $theme-color;margin: 0 24px;letter-spacing: 1px;transition: .3s;
        &.router-link-exact-active,&:hover { font-weight: bold;transform: scale(1.15);}
      }
      .el-icon-search {
        font-size: 32px;color: $color-white;margin-left: 40px;transition: .3s;
        &:hover { transform: scale(1.12);font-weight: bold;}
      }
    }
  }
  @media screen and (max-width: 750px) {
    .top-box {
      padding: 10px 14px;
      .logo {
        display: none;
        .logo-icon { height: 40px;margin-right: 5px;}
        .logo-text { font-size: 16px;letter-spacing: 0;}
      }
      .nav-list { 
        white-space: nowrap;width: 100%;overflow: auto;padding-top: 6px;
        &::-webkit-scrollbar {width: 0;height: 0;background-color: transparent;}
        .nav-item { 
          font-size: 15px;margin: 0 10px;
          &:first-child { margin-left: 7px;}
          &.router-link-exact-active,&:hover { transform: scale(1.08);}
        }
      }
      .nav-more { display: none;}
      .nav-more-text { font-size: 14px;color: #fff;margin-right: 5px;line-height: 1.2;word-spacing: 5px;text-shadow: 0 3px 6px $theme-color-opacity1;}
      .nav-en { font-size: 12px;word-spacing: 0;}
      .nav-more-icon { display: block;font-size: 20px;color: #fff;margin-right: -2px;text-shadow: 0 3px 6px $theme-color-opacity1;}
    }
    >>> .el-drawer__header { margin-bottom: 5vh;}
    .app-nav-icon { margin-top: 26px;height: 64px;}
    .app-nav {
      width: 100%;
      .app-nav-item {
        width: 100%;text-align: center;display: block;line-height: 2;padding: 10px 0;border-bottom: 1px solid #eee;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderRed.vue